import { ChangeDetectionStrategy, Component, DestroyRef, computed, inject, viewChild } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { KiMandantSectionComponent } from '../../settings/ki-mandant-section/ki-mandant-section.component';
import { VerwaltungBereich } from './verwaltung-bereich';
import { VerwaltungStore } from './verwaltung.store';
import { VwUngespeichertComponent } from './vw-ungespeichert.component';

@Component({
  selector: 'app-verwaltung-ki',
  standalone: true,
  imports: [KiMandantSectionComponent, VwUngespeichertComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <app-ki-mandant-section [firmenname]="store.firmenname()" />
    <app-vw-ungespeichert [bereich]="this" />
  `,
  styles: `
    :host {
      display: block;
    }
  `,
})
export class VerwaltungKiComponent implements VerwaltungBereich {
  protected readonly store = inject(VerwaltungStore);
  private readonly section = viewChild(KiMandantSectionComponent);

  readonly hatUngespeicherteAenderungen = computed(() => {
    const section = this.section();
    return !!section && (section.istGeaendert() || section.hatEntwurf());
  });

  readonly kannSpeichern = computed(() => {
    const section = this.section();
    return !!section && section.istGeaendert() && section.istGueltig();
  });

  constructor() {
    this.store.bereichAnmelden(this);
    inject(DestroyRef).onDestroy(() => this.store.bereichAbmelden(this));
  }

  speichern(): Observable<void> {
    const section = this.section();
    return section?.istGeaendert() ? section.speichern$() : EMPTY;
  }

  verwerfen(): void {
    this.section()?.zuruecksetzen();
  }
}
